import { render, staticRenderFns } from "./SVGStepsFolder.vue?vue&type=template&id=4e2412e4&scoped=true&"
import script from "./SVGStepsFolder.vue?vue&type=script&lang=js&"
export * from "./SVGStepsFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2412e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e2412e4')) {
      api.createRecord('4e2412e4', component.options)
    } else {
      api.reload('4e2412e4', component.options)
    }
    module.hot.accept("./SVGStepsFolder.vue?vue&type=template&id=4e2412e4&scoped=true&", function () {
      api.rerender('4e2412e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGStepsFolder.vue"
export default component.exports